const lqcReportReducer = (
    state = {
        showReportTab: false,
        lqcScoreDescriptions: {
            overallLeadQualification:"",
            overallLeadCalling:"",
            overallLeadQualificationValueMessage: "",
            overallLeadCallingValueMessage:""
        },
        lqcReportDate:""
    },
    action: {
        type: "SET_SHOW_REPORT_TAB" | "SET_LQC_OVERALL_DESCRIPTIONS" | "SET_LQC_REPORT_DATE"
        payload: any;
    }
) => {
    switch (action.type) {
        case "SET_SHOW_REPORT_TAB":
            return { ...state, showReportTab: action.payload };
        case "SET_LQC_OVERALL_DESCRIPTIONS":
            return { ...state, lqcScoreDescriptions: action.payload };
        case "SET_LQC_REPORT_DATE":
            return { ...state, lqcReportDate: action.payload };
        default:
            return state;
    }
};

export default lqcReportReducer;